import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { TouchableOpacity, TouchableOpacityProps } from 'react-native';

export const ScanButton = memo(
  ({ color, ...props }: TouchableOpacityProps & { color: string }) => {
    const { rpx } = useResponsiveContext();
    return (
      <TouchableOpacity
        hitSlop={{
          left: rpx(10),
          top: rpx(10),
          right: rpx(10),
          bottom: rpx(10),
        }}
        {...props}
      >
        <Icon name="scan" size={rpx(24)} color={color} />
      </TouchableOpacity>
    );
  },
);
